import gql from 'graphql-tag';

const allRuleDefinitionsQuery = gql`
  query GetAllRuleDefinitions {
    externalAllRules {
      id
      name
      category
      description
      value
    }
  }
`;

export default allRuleDefinitionsQuery;
